import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';

type ActiveInSessionFilters = {
  accountRef: string;
};

type UsageFilters = {
  accountRef: string;
  usageType?: UsageTypeValue;
  chartType?: ChartTypeValue;
};

export const simProductsGraphsQueries = {
  all: ['SimProductsGraphs'],
  activeInSession: (filters: ActiveInSessionFilters) => [
    ...simProductsGraphsQueries.all,
    'Active in Session',
    filters,
  ],
  usage: (filters: UsageFilters) => [...simProductsGraphsQueries.all, 'Usage', filters],
};
